import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Stack, Typography, styled } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TextField from "@mui/material/TextField";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { format, parseISO } from "date-fns";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import WelcomeNameContainer from "../LaunchComponent/WelcomeNameContainer";
import { fetchCampaignsData, handleCampainIDSelection, resetSubmissionButton } from "../Redux/Mailer";
import { handleGenerateReminder, handleReminderLoading } from "../Redux/Reminder";
import ReminderDataDisplay from "./ReminderDataDisplay";
import "./ReminderForm.css";
const CustomRadio = styled(Radio)(({
  theme
}) => ({
  "&.Mui-checked": {
    color: "#9c27b0" // Purple for the checked state
  },
  "& .MuiSvgIcon-root": {
    fontSize: "1.5rem" // Custom icon size
  },
  "&:hover": {
    backgroundColor: "rgba(156, 39, 176, 0.08)" // Optional hover effect
  }
}));
const WhiteBorderTextField = styled(TextField)`
 & label.Mui-focused {
  color: #a804ff;
 }
 & .MuiOutlinedInput-root {
  &.Mui-focused fieldset {
   border-color: #a814ff;
   border-width: 1px;
  }
 }
`;
const ReminderForm = ({
  programList,
  categoryNameReminder,
  setCategoryNameReminder,
  mailerChild,
  setMailerChild,
  setMailerParent,
  mailerParent
}) => {
  const [programNameReminder, setProgramNameReminder] = useState("");
  const [launchDateReminder, setLaunchDateReminder] = useState();
  const [targAudienceReminder, setTargAudienceReminder] = useState("");
  const [lastDateReminder, setLastDateReminder] = useState();
  const [reminderMsgReminder, setReminderMsgReminder] = useState("");
  const [keyPointsReminder, setKeyPointsReminder] = useState("");
  const [contactInfoReminder, setContactInfoReminder] = useState("");
  const [callToActionReminder, setCallToActionReminder] = useState("");
  const [campaign, setCampaign] = useState(0);
  const [additionalResourcesReminder, setAdditionalResourcesReminder] = useState("");
  const campaignList = useSelector(state => state.model.campaignList);
  const options = campaignList.message !== "No campaign for this user." && campaignList.length > 0 ? campaignList.map(item => ({
    id: item.id,
    name: item.name
  })) : [];
  const mailList = useSelector(state => state.model.mailList);
  const [isNameIncludes, setIsNameIncluded] = useState(false);
  const [isReminderMailGenerationClicked, setIsReminderGenerationClicked] = React.useState(false);
  const [isReminderNavigatedToForm, setIsReminderNavigatedToForm] = useState(false);
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 200
      }
    }
  };
  const dispatch = useDispatch();
  const [isReminderMailGenerated, setIsReminderMailGenerated] = useState("init");
  const handleCampaignID = val => {
    if (val) {
      setCampaign(val.id);
      let campaignID = val.id;
      let data = campaignList.filter(val => val.id == campaignID);
      setProgramNameReminder(data[0].name);
      const item = data[0].selectedItems.filter(val => val.title == "Learning Journey Start");
      const endDateItem = data[0].selectedItems.filter(val => val.title == "Registration End");
      let initialDate;
      let regEndDate;
      if (item.length != 0) {
        initialDate = format(parseISO(item[0].date), "yyyy-MM-dd");
      } else {
        initialDate = "";
      }
      if (endDateItem.length != 0) {
        regEndDate = format(parseISO(endDateItem[0].date), "yyyy-MM-dd");
      } else {
        regEndDate = "";
      }
      setLaunchDateReminder(initialDate);
      setLastDateReminder(regEndDate);
      dispatch(handleCampainIDSelection(campaignID));
    }
  };
  useEffect(() => {
    dispatch(fetchCampaignsData(categoryNameReminder));
  }, []);
  const today = new Date().toISOString().split("T")[0];
  const handleReset = () => {
    setProgramNameReminder("");
    setReminderMsgReminder("");
    dispatch(resetSubmissionButton());
    setCallToActionReminder("");
    setContactInfoReminder("");
    setAdditionalResourcesReminder("");
    setKeyPointsReminder("");
    setLastDateReminder("");
    setLaunchDateReminder("");
    setTargAudienceReminder("");
    setMailerChild("");
    setMailerParent("");
    setCategoryNameReminder("Program");
  };
  const handleRadioChange = e => {
    setCategoryNameReminder(e.target.value);
    setValue("");
    handleRadioChangeReset();
    dispatch(fetchCampaignsData(e.target.value));
  };
  const handleRadioChangeReset = () => {
    setProgramNameReminder("");
    setReminderMsgReminder("");
    dispatch(resetSubmissionButton());
    setCallToActionReminder("");
    setContactInfoReminder("");
    setAdditionalResourcesReminder("");
    setKeyPointsReminder("");
    setLastDateReminder("");
    setLaunchDateReminder("");
    setTargAudienceReminder("");
    setCampaign(0);
    setIsReminderMailGenerated("init");
    setIsReminderNavigatedToForm(false);
  };
  const [value, setValue] = React.useState(null);
  const handleChange = event => {
    if (event.target.value == "no") {
      setCampaign(0);
      dispatch(handleCampainIDSelection(0));
    }
    handleRadioChangeReset();
    setValue(event.target.value);
  };
  const handleReminderMailGeneration = () => {
    setIsReminderGenerationClicked(true);
    let values = {
      programNameReminder: programNameReminder,
      launchDateReminder: launchDateReminder,
      targAudienceReminder: targAudienceReminder,
      lastDateReminder: lastDateReminder,
      reminderMsgReminder: reminderMsgReminder,
      keyPointsReminder: keyPointsReminder,
      contactInfoReminder: contactInfoReminder,
      callToActionReminder: callToActionReminder,
      additionalResourcesReminder: additionalResourcesReminder,
      currentContent: "",
      sessionID: localStorage.getItem("sessionId"),
      categoryName: categoryNameReminder
    };
    dispatch(handleGenerateReminder(values));
  };
  const handleProgramNameChange = currentName => {
    setProgramNameReminder(currentName);
  };
  const HtmlTooltip = styled(({
    className,
    ...props
  }) => <Tooltip {...props} classes={{
    popper: className
  }} />)(({
    theme
  }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9"
    }
  }));
  return <>
   {!isReminderMailGenerationClicked ? <Stack>
     <Stack sx={{
        width: "100%"
      }}>
      <WelcomeNameContainer currentComp="Reminder" />
      <Stack spacing={1} className="mail-form-container-stack">
       <div className="mail-form-container">
        <div className="mailer-form-categories-section">
         <label class="mailer-form-categories-container">
          <span className="mailer-form-categories-text">Learning Program</span>
          <input type="radio" checked={categoryNameReminder === "Program"} value="Program" name="radio-category" onChange={handleRadioChange} />
          <span class="mailer-form-categories-checkmark"></span>
         </label>
         <label class="mailer-form-categories-container">
          <span className="mailer-form-categories-text">Event</span>
          <input type="radio" checked={categoryNameReminder === "Event"} value="Event" name="radio-category" onChange={handleRadioChange} />
          <span class="mailer-form-categories-checkmark"></span>
         </label>

         <label class="mailer-form-categories-container">
          <span className="mailer-form-categories-text">Webinar</span>
          <input type="radio" checked={categoryNameReminder === "Webinar"} value="Webinar" name="radio-category" onChange={handleRadioChange} />
          <span class="mailer-form-categories-checkmark"></span>
         </label>
        </div>
        <Stack direction={"row"} sx={{
              alignItems: "flex-start"
            }} spacing={2}>
         <Stack direction={"row"} sx={{
                alignItems: "flex-start"
              }} spacing={2}>
          <Stack direction={"column"}>
           <Typography>
            Is this communication part of any campaign?
            <span className="migrated-style-reminderform-8ab419-1">*</span>
           </Typography>
           <Typography>(If yes, select the campaign name)</Typography>
          </Stack>

          <FormControl>
           <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group" value={value} onChange={handleChange} sx={{
                    paddingLeft: "20px"
                  }}>
            <FormControlLabel value="yes" control={<CustomRadio icon={<RadioButtonUncheckedIcon className="migrated-style-reminderform-8ab419-2" />} // Empty circle when unchecked
                    checkedIcon={<CheckCircleOutlineIcon className="migrated-style-reminderform-8ab419-3" />} // Checkmark inside circle when checked
                    />} label="Yes" />
            <FormControlLabel value="no" control={<CustomRadio icon={<RadioButtonUncheckedIcon className="migrated-style-reminderform-8ab419-4" />} // Empty circle when unchecked
                    checkedIcon={<CheckCircleOutlineIcon className="migrated-style-reminderform-8ab419-5" />} // Checkmark inside circle when checked
                    />} label="No" />
           </RadioGroup>
          </FormControl>
         </Stack>
         {value == "yes" && <Stack direction={"row"} sx={{
                alignItems: "center"
              }} spacing={2}>
           <Typography>
            Select the campaign <span className="migrated-style-reminderform-8ab419-6">*</span>
           </Typography>
           <Stack className="mail-form-headers" sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginBottom: "10px",
                  m: 1,
                  width: 200,
                  mt: 3
                }} direction={"row"} spacing={2}>
            {/* <Select value={campaign} onChange={handleCampaignID} MenuProps={MenuProps}>
             {campaignList.message != "No campaign for this user." &&
              campaignList.length > 0 &&
              campaignList.map((item, index) => (
               <MenuItem key={index + 1} value={item.id}>
                {item.name}
               </MenuItem>
              ))}
             </Select> */}
            <Autocomplete value={options.find(option => option.id === campaign) || null} onChange={(event, newValue) => {
                    handleCampaignID(newValue);
                  }} options={options} getOptionLabel={option => option.name || ""} ListboxProps={{
                    style: {
                      maxHeight: "150px",
                      // Fixed height for the dropdown
                      overflowY: "auto" // Enable vertical scrolling
                    }
                  }} renderInput={params => <TextField sx={{
                    "& .MuiOutlinedInput-root": {
                      padding: "2px !important"
                    }
                  }} {...params} variant="outlined" />} filterSelectedOptions={false} />
           </Stack>
          </Stack>}
        </Stack>
        <div className="mail-form-wrap">
         <div className="mail-form-inner-wrap">
          <Stack className="mail-form-headers" sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginBottom: "10px",
                  position: "relative"
                }}>
           <Typography sx={{
                    fontSize: "16px"
                  }}>
            <span>
             Name<span className="migrated-style-reminderform-8ab419-7">*</span>
            </span>
            <HtmlTooltip arrow title={<React.Fragment>
               {categoryNameReminder == "Program" ? <p> Enter the program name </p> : categoryNameReminder == "Event" ? <p> Enter the event name</p> : categoryNameReminder == "Microsite/Tool/Platform" ? <p> Enter the Microsite/Tool/Platform name</p> : <p> Enter the Webinar name</p>}
              </React.Fragment>}>
             <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-reminderform-8ab419-8" />
            </HtmlTooltip>
           </Typography>
           {/* <WhiteBorderTextField
            placeholder={
             categoryNameReminder == "Program"
              ? "e.g: Java Full Stack"
              : categoryNameReminder == "Event"
              ? "e.g: ATCI Event"
              : categoryNameReminder == "Microsite/Tool/Platform"
              ? "e.g: ATCI Learning"
              : "e.g: ATCI Webinar"
            }
            id="multiline"
            multiline
            disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
            minRows={1}
            maxRows={2}
            value={programNameReminder}
            InputLabelProps={{ shrink: false }}
            InputProps={{
             readOnly: value === "yes" && campaign != 0,
            }}
            onChange={(event) => {
             setIsReminderMailGenerated("init");
             handleProgramNameChange(event.target.value);
            }}
            fullWidth
            /> */}
             <Autocomplete id="free-solo-demo" freeSolo value={programNameReminder} onChange={(event, newValue) => {
                    handleProgramNameChange(newValue || ""); // Ensure value updates when selecting a suggestion
                    setIsReminderMailGenerated("init");
                  }} onInputChange={(event, newInputValue) => {
                    handleProgramNameChange(newInputValue); // Update state when typing
                  }} disabled={!value || value === "yes"} inputprops={{
                    readOnly: value === "yes"
                  }} options={programList.map(option => option.programname)} renderInput={params => <WhiteBorderTextField {...params} id="multiline" multiline minRows={1} maxRows={2} fullWidth placeholder={categoryNameReminder === "Program" ? "e.g: Java Full Stack" : categoryNameReminder === "Event" ? "e.g: ATCI Event" : categoryNameReminder === "Microsite/Tool/Platform" ? "e.g: ATCI Learning" : "e.g: ATCI Webinar"} disabled={!value || value === "yes" && campaign === 0} />} />
          </Stack>
          <Stack className="mail-form-headers" sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginBottom: "10px"
                }}>
           <Typography sx={{
                    fontSize: "16px"
                  }}>
            <span>
             Launch Date
             <span className="migrated-style-reminderform-8ab419-9">*</span>
            </span>
            <HtmlTooltip arrow title={<React.Fragment>
               <p>Select the original launch or start date.</p>
              </React.Fragment>}>
             <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-reminderform-8ab419-10" />
            </HtmlTooltip>
           </Typography>
           <input type="date" className="maindate migrated-style-reminderform-8ab419-11" min={today} disabled={value == null || value == "yes" && campaign == 0 ? true : false} readOnly={value == "yes" && campaign != 0 && launchDateReminder != "" ? true : false} onChange={event => {
                    setLaunchDateReminder(event.target.value);
                    setIsReminderMailGenerated("init");
                  }} value={launchDateReminder} onKeyDown={e => e.preventDefault()} />
          </Stack>
         </div>
         <div className="mail-form-inner-wrap">
          <Stack className="mail-form-headers" sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginBottom: "10px"
                }}>
           <Typography sx={{
                    fontSize: "16px"
                  }}>
            <span>
             Target Audience<span className="migrated-style-reminderform-8ab419-12">*</span>
            </span>
            <HtmlTooltip arrow title={<React.Fragment>
               <p>Specify target audience</p>
              </React.Fragment>}>
             <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-reminderform-8ab419-13" />
            </HtmlTooltip>
           </Typography>
           <WhiteBorderTextField
                  // placeholder="Enter Target Audience"
                  placeholder="e.g: CL10-CL8 across ATCI" id="multiline" multiline InputLabelProps={{
                    shrink: false
                  }} minRows={1} maxRows={2} disabled={value == null || value == "yes" && campaign == 0 ? true : false} onChange={event => {
                    setTargAudienceReminder(event.target.value);
                    setIsReminderMailGenerated("init");
                  }} fullWidth value={targAudienceReminder} />
          </Stack>
          <Stack className="mail-form-headers" sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginBottom: "10px"
                }}>
           <Typography sx={{
                    fontWeight: "400",
                    fontSize: "16px"
                  }}>
            <span>
             Contact Info<span className="migrated-style-reminderform-8ab419-14">*</span>
            </span>
            <HtmlTooltip arrow title={<React.Fragment>
               <p>Enter contact info for queries.</p>
              </React.Fragment>}>
             <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-reminderform-8ab419-15" />
            </HtmlTooltip>
           </Typography>
           <WhiteBorderTextField
                  // placeholder="Enter Contact Info"
                  placeholder="e.g: support@jfs.com" id="multiline" multiline maxRows={1} disabled={value == null || value == "yes" && campaign == 0 ? true : false} InputLabelProps={{
                    shrink: false
                  }} onChange={event => {
                    setContactInfoReminder(event.target.value);
                    setIsReminderMailGenerated("init");
                  }} fullWidth value={contactInfoReminder} />
          </Stack>
         </div>
         <Stack className="mail-form-headers" sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginBottom: "10px"
              }}>
          <Typography sx={{
                  fontWeight: "400",
                  fontSize: "16px"
                }}>
           <span>
            Last Date of Registration/Nomination<span className="migrated-style-reminderform-8ab419-16">*</span>
            <span className="migrated-style-reminderform-8ab419-17"></span>
           </span>
           <HtmlTooltip arrow title={<React.Fragment>
              <p>Enter the final date for registration or nomination, if applicable </p>
             </React.Fragment>}>
            <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-reminderform-8ab419-18" />
           </HtmlTooltip>
          </Typography>

          <input type="date" className="maindate migrated-style-reminderform-8ab419-19" min={today} disabled={value == null || value == "yes" && campaign == 0 ? true : false} readOnly={value == "yes" && campaign != 0 && lastDateReminder != "" ? true : false} max={launchDateReminder} onChange={event => {
                  setLastDateReminder(event.target.value);
                  setIsReminderMailGenerated("init");
                }} value={lastDateReminder} onKeyDown={e => e.preventDefault()} />
         </Stack>
         <Stack className="mail-form-headers" sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginBottom: "10px"
              }}>
          <Typography sx={{
                  fontWeight: "400",
                  fontSize: "16px"
                }}>
           {/* Key Highlights <span style={{ color: "lightgray" }}></span> */}
           <span>
            Reminder Message <span className="migrated-style-reminderform-8ab419-20"></span>
           </span>
           <HtmlTooltip arrow title={<React.Fragment>
              <p>
               Include a brief message to remind the recipients about the{" "}
               {categoryNameReminder == "Program" ? "Program" : categoryNameReminder == "Event" ? "Event" : categoryNameReminder == "microsite" ? "microsite" : "Webinar"}{" "}
              </p>
             </React.Fragment>}>
            <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-reminderform-8ab419-21" />
           </HtmlTooltip>
          </Typography>
          <WhiteBorderTextField
                //placeholder="Key Highlights"
                placeholder="e.g: Register for your [Program Name] by [Date]" id="multiline" multiline disabled={value == null || value == "yes" && campaign == 0 ? true : false} minRows={1} InputLabelProps={{
                  shrink: false
                }} onChange={event => {
                  //setKeyPoints(event.target.value);
                  setReminderMsgReminder(event.target.value);
                  setIsReminderMailGenerated("init");
                  //   setAdditionalInfo(event.target.value);
                  //   setIsMailGenerated("enabled");
                }}
                // sx={{ width: "20rem" }}
                fullWidth
                //    value={keyPoints}
                value={reminderMsgReminder} />
         </Stack>
         <Stack className="mail-form-headers" sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginBottom: "10px"
              }}>
          <Typography sx={{
                  fontWeight: "400",
                  fontSize: "16px"
                }}>
           <span>Call To Action </span>
           <span className="migrated-style-reminderform-8ab419-22"></span>
           <HtmlTooltip arrow title={<React.Fragment>
              <p>Encourage participants to take action. </p>
             </React.Fragment>}>
            <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-reminderform-8ab419-23" />
           </HtmlTooltip>
          </Typography>
          <WhiteBorderTextField id="multiline" multiline minRows={3} disabled={value == null || value == "yes" && campaign == 0 ? true : false} InputLabelProps={{
                  shrink: false
                }} onChange={event => {
                  setCallToActionReminder(event.target.value);
                  setIsReminderMailGenerated("init");
                }} fullWidth value={callToActionReminder} />
         </Stack>

         <Stack className="mail-form-headers" sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginBottom: "10px"
              }}>
          <Typography sx={{
                  fontWeight: "400",
                  fontSize: "16px"
                }}>
           <span>
            Additional Resources/Links <span className="migrated-style-reminderform-8ab419-24"></span>
           </span>
           <HtmlTooltip arrow title={<React.Fragment>
              <p>Add any relevant links or resources</p>
             </React.Fragment>}>
            <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-reminderform-8ab419-25" />
           </HtmlTooltip>
          </Typography>
          <WhiteBorderTextField placeholder="Access your course materials [Link]" id="multiline" multiline minRows={3} disabled={value == null || value == "yes" && campaign == 0 ? true : false} InputLabelProps={{
                  shrink: false
                }} onChange={event => {
                  setAdditionalResourcesReminder(event.target.value);
                  setIsReminderMailGenerated("init");
                }} fullWidth value={additionalResourcesReminder} />
         </Stack>
        </div>
       </div>
       <div className="btn-container">
        {isReminderNavigatedToForm && <button className="reset-btn" onClick={() => {
              setIsReminderMailGenerated("generateOutput");
              setIsReminderGenerationClicked(true);
            }}>
          Next
         </button>}

        {programNameReminder == "" || launchDateReminder == undefined || lastDateReminder == undefined || targAudienceReminder == "" || contactInfoReminder == "" || isReminderMailGenerated !== "init" ? <div className="mailer-generate-btn-disable">
          <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"}></img>
          <span>Generate</span>
         </div> : <div className="mailer-generate-btn" onClick={() => {
              handleReminderMailGeneration();
              setIsReminderMailGenerated("generateOutput");
              dispatch(handleReminderLoading());
            }}>
          <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"}></img>
          <span>Generate</span>
         </div>}
       </div>
      </Stack>
     </Stack>
    </Stack> : isReminderMailGenerated == "generateOutput" ? <>
     <ReminderDataDisplay setIsReminderGenerationClicked={setIsReminderGenerationClicked} categoryNameReminder={categoryNameReminder} mailerChild={mailerChild} mailerParent={mailerParent} handleReset={handleReset} setIsReminderNavigatedToForm={setIsReminderNavigatedToForm} setIsReminderMailGenerated={setIsReminderMailGenerated} programNameReminder={programNameReminder} />
    </> : <></>}
  </>;
};
export default ReminderForm;
